import { html } from '@shared/utils/rendering/html';

const ProgressCard = ({ title, progress, ...props }) => {
    return html`
        <div class="progress-card ${props?.css ?? ''}" ...${props}>
            <div class="header">${title?.precedent}${title.text}${title?.antecedent}</div>
            <div class="body">
                <span class="value"
                    >${
                        progress?.value?.toFixed(progress?.decimalPlaces ?? 2) ?? 0.0
                    }${progress.unit ?? '%'}</span
                >
            </div>
        </div>
    `;
};

export default ProgressCard;
